var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"formPanel",staticClass:"go-form-panel",staticStyle:{"height":"100%","box-sizing":"border-box"}},[_c('div',{staticClass:"go-form-panel-body"},[_c('div',{staticStyle:{"position":"relative"}},[_c('form',{domProps:{"innerHTML":_vm._s(_vm.getFormContent())}})])])])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./goingsrc/vueCom/formVue/go-from-ctl.vue